// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ab4fb390","952":"925a7ce2"}[chunkId] + ".chunk.js";
};